import { render, staticRenderFns } from "./NestedComponent.vue?vue&type=template&id=ae12e698&"
import script from "./NestedComponent.vue?vue&type=script&lang=js&"
export * from "./NestedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports